var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{attrs:{"id":"collection-banner"}}),_c('div',{staticClass:"container"},[_c('personal-collections')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }